import { selector } from 'recoil';
import { OnlineSales } from 'gw-edge-client';
import {
    isAgricultureLob,
    isDefaultShortRateReason,
    shouldHideEdiChooseStatus
} from '../../utils/externalCasesUtil';
import { EdiCaseStatusMap } from '../../pages/CheckoutPage/steps/DatesAndCancellationStep';
import { convertDateToLocalDateDTO, getAsapCancelDate } from '../../utils/dateUtil';
import { sortExternalCasesByFlavourName } from '../../utils/sortingUtil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { refreshExternalCasesAtom } from '../atoms/refreshExternalCasesAtom';

export const externalCasesSelector = selector({
    key: 'externalCasesSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        get(refreshExternalCasesAtom);
        const response = await OnlineSales.generateAndGetEdiCases(jobNumber, sessionId);
        const externalCases = response.externalCases ?? [];

        return externalCases
            .map((ediCase) =>
                shouldHideEdiChooseStatus(ediCase.lobCode ?? '') ||
                (ediCase.status === EdiCaseStatusMap.ReadyForSend &&
                    isAgricultureLob(ediCase.lobCode ?? ''))
                    ? { ...ediCase, status: EdiCaseStatusMap.PendingCompletion }
                    : ediCase
            )
            .map((ediCase) =>
                isDefaultShortRateReason(ediCase.cancellationReason ?? '')
                    ? {
                          ...ediCase,
                          cancellationDate: convertDateToLocalDateDTO(
                              getAsapCancelDate(isAgricultureLob(ediCase.lobCode ?? ''))
                          )
                      }
                    : ediCase
            )
            .sort(sortExternalCasesByFlavourName);
    }
});
